// extracted by mini-css-extract-plugin
export default {"cls1":"Dj1eSPAjPB0oNs9o3qS6","cls2":"ZZeySuE3K_xGZmfrO7zv Dj1eSPAjPB0oNs9o3qS6"};